<ng-template cdkPortal #modalTemplatePortal>
  <div cdkTrapFocus class="modal-dialog">
    <div
      class="modal-content"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="!showTitlebar && titleText ? titleText : null"
      [attr.aria-labelledby]="showTitlebar ? templateUUIDs.get('dialog-heading') : null"
      [attr.aria-describedby]="templateUUIDs.get('dialog-content')"
    >
      <div *ngIf="showTitlebar" class="modal-header">
        <h2 [id]="templateUUIDs.get('dialog-heading')" class="modal-title">
          {{ titleText }}
        </h2>
        <button
          app-button
          appTooltip="Close"
          *ngIf="!disableClose"
          (click)="onClose()"
          type="button"
          class="close"
          data-dismiss="modal"
          [attr.aria-label]="'ngx-shared-close-dialog' | translate | async"
        >
          <span class="ahe-icon ahe-icon-close-white" aria-hidden="true"></span>
        </button>
      </div>

      <div *ngIf="description" [id]="templateUUIDs.get('dialog-description')" class="cdk-visually-hidden">
        <ng-template [ngTemplateOutlet]="descriptionTemplateRef || default"> </ng-template>
        <ng-template #default>
          <p>{{ descriptionText }}</p>
        </ng-template>
      </div>

      <div [id]="templateUUIDs.get('dialog-content')" class="modal-body scrollable-body" [attr.tabindex]="isScrollable ? '0' : null" #modalBodyRef>
        <ng-container *ngIf="contentText; else modalBodyContent">
          <p class="modal-content-text">{{ contentText }}</p>
        </ng-container>
        <ng-template #modalBodyContent><ng-content></ng-content></ng-template>
      </div>

      <div *ngIf="showFooter" class="modal-footer">
        <button
          #cancelButton
          *ngIf="cancelButtonText"
          type="button"
          class="action-button btn btn-secondary"
          [disabled]="disableCancel"
          (click)="onCancel()"
          data-dismiss="modal"
          [attr.cdkFocusInitial]="focusOnConfirm || showTitlebar ? null : ''"
        >
          {{ cancelButtonText }}
        </button>

        <button
          #confirmButton
          *ngIf="confirmButtonText"
          type="button"
          class="action-button btn btn-primary"
          [disabled]="disableConfirm"
          (click)="onConfirm()"
          [attr.cdkFocusInitial]="focusOnConfirm && !showTitlebar ? '' : null"
        >
          {{ confirmButtonText }}
        </button>
        <span *ngIf="isValidFooterMessage(footerMessage)" class="footer-msg">{{ footerMessage }}</span>
      </div>
    </div>
  </div>
</ng-template>
